import { useEffect } from 'react'
import type { ReactElement } from 'react'
import { Route, Routes, useLocation } from 'react-router'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Products from './pages/Products'
import Partners from './pages/Partners'
import About from './pages/About'
import Contact from './pages/Contact'
import Developers from './pages/Developers'
import NotFound from './pages/NotFound'
import Legal from './pages/Legal'
import Download from './pages/Download'
import AccountRegister from './pages/account/AccountRegister'
import AccountForgotPassword from './pages/account/AccountForgotPassword'
import AccountVerifyEmail from './pages/account/AccountVerifyEmail'
import AccountResetPassword from './pages/account/AccountResetPassword'
import { legalPageList } from './data/legal/legalPages'
import { downloadableApps, downloadPagePath } from './data/downloads'
import { ACCOUNT_PATHS } from './account/accountPaths'

// Scroll to the #fragment target when there is one (e.g. /terms#disclaimer linked from an app), otherwise to the top.
function ScrollOnNavigate(): null {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    const target: HTMLElement | null = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null
    if (target) target.scrollIntoView()
    else window.scrollTo(0, 0)
  }, [pathname, hash])
  return null
}

export default function App(): ReactElement {
  return (
    <div className="App">
      <Navbar />
      <ScrollOnNavigate />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/developers" element={<Developers />} />
          {legalPageList.map((p) => <Route key={p.id} path={p.path} element={<Legal page={p} />} />)}
          {downloadableApps.map((a) => <Route key={a.id} path={downloadPagePath(a.id)} element={<Download key={a.id} app={a} />} />)}
          <Route path={ACCOUNT_PATHS.register} element={<AccountRegister />} />
          <Route path={ACCOUNT_PATHS.forgotPassword} element={<AccountForgotPassword />} />
          <Route path={ACCOUNT_PATHS.verifyEmail} element={<AccountVerifyEmail />} />
          <Route path={ACCOUNT_PATHS.resetPassword} element={<AccountResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}
